/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Location, District } from './content-request';
import { IContentBlockData } from './content-block';
import { ContentBlockType } from './content-block-type';
import { CensusGeo } from './census.geo';
import { ContentBlockTableType } from './table-type';

export class ContentDataMap implements IContentBlockData {
  LOCATION: Location;
  IMAGE_DATA: string; // Base64 result of map manipulation
  TYPE: ContentBlockType = ContentBlockType.MAP;

  constructor(values: any = {}){
    Object.assign(this, values);

    if(values.LOCATION)
      this.LOCATION = new Location(values.LOCATION);
  }
}

export class ContentDataStreetView implements IContentBlockData {
  LOCATION: Location;
  IMAGE_DATA: string; // Base64 result of map manipulation
  TYPE: ContentBlockType = ContentBlockType.STREET_VIEW;

  constructor(values: any = {}){
    Object.assign(this, values);

    if(values.LOCATION)
      this.LOCATION = new Location(values.LOCATION);
  }
}

export class ContentDataEditableText implements IContentBlockData {
  TEXT: string;
  TYPE: ContentBlockType = ContentBlockType.EDITABLE_TEXT;

  constructor(values: any = {}){
    Object.assign(this, values);
    if(!values.TEXT)
      this.TEXT = '';
  }
}

export class ContentDataStaticText implements IContentBlockData {
  TEXT: string;
  TYPE: ContentBlockType = ContentBlockType.STATIC_TEXT;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}

export class ContentDataPSGeneral implements IContentBlockData {
  TEXT: string; // Result from Blurbs
  TYPE: ContentBlockType = ContentBlockType.PREPARED_STATEMENT_GENERAL;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}

export class ContentDataPSIBIS implements IContentBlockData {
  TEXT: string; // Result from Blurbs
  TYPE: ContentBlockType = ContentBlockType.PREPARED_STATEMENT_IBIS;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}

export class ContentBlockDataError implements IContentBlockData {
  MESSAGE: string;
  TYPE: ContentBlockType = ContentBlockType.ERROR;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}


export class ContentDataDistrict implements IContentBlockData {
  POI: District[];
  IMAGE_DATA: string; // Base64 result of map manipulation
  TYPE: ContentBlockType = ContentBlockType.DISTRICT;
  LOCATION: Location;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}

export class ContentDataEditableTable implements IContentBlockData {
  TEXT: string;
  COLUMNS: CensusGeo[];
  TABLE_TYPE: ContentBlockTableType;
  TYPE: ContentBlockType = ContentBlockType.EDITABLE_TABLE;

  constructor(values: any = {}){
    Object.assign(this, values);
  }
}
